
export const ConditionalBlock = (props) => {

    return (
             (props.condition)?<>{props.children}</>:<></>
    );
}